// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"575":"01ee23a2","748":"b54e955d","884":"78d27913"}[chunkId] + ".chunk.css";
};